import styled, { css } from 'styled-components';

import { Media } from '../../assets/Mixins.style';
import { Button as commonButton } from '../../assets/Common/Button.style';

import {
  Section as commonSection,
  Wrapper as commonWrapper,
  Content as commonContent,
  Panel as commonPanel,
  PanelInner as commonPanelInner,
  Information as commonInformation,
  Text as commonText,
} from '../../assets/Common/Content.style';

import { Center as commonCenter } from '../../assets/Common/Center.style';

import {
  SelectionHolder as commonSectionHolder,
  Selection as commonSelection,
  SelectionInput as commonSectionInput,
  SelectionCheckmark as commonSectionCheckmark,
} from '../../assets/Common/Selection.style';

export const Section = styled.div`
  ${commonSection}
`;

export const Wrapper = styled.div`
  ${commonWrapper}
`;

export const Content = styled.div`
  ${commonContent}
`;

export const Panel = styled.div`
  ${commonPanel}
  display: block;
`;

export const PanelInner = styled.div`
  ${commonPanelInner}
  min-height: 100%;

  ${(props) =>
    props.center &&
    css`
      justify-content: center;
    `}
`;

export const Center = styled.div`
  ${commonCenter}
`;

export const Information = styled.div`
  ${commonInformation}
  max-width: 530px;
  text-align: center;
`;

export const Text = styled.p`
  ${commonText}
`;

export const Box = styled.div`
  /* display: grid; */
  /* grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); */
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 0px 15px;

  ${Media.lg`
    grid-gap: 20px;
    padding: 20px 0;
  `}
`;

export const Navigation = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  min-height: 46px;
  margin-top: 30px;
  padding: 15px 30px;
  position: sticky;
  top: 0px;
  z-index: 1;
  background: ${(props) =>
    props.theme.background}; //have no idea why this is not working
  background: #fff;

  ${Media.xlg`
    padding: 0 15px;
  `}

  ${Media.lg`
    flex-direction: column-reverse;
    flex-wrap: wrap;
    margin-top: 20px;
    padding: 0;
  `}
`;

export const NavigationColumn = styled.div`
  display: block;

  ${Media.lg`
    width: 100%;
  `}
`;

export const SelectionHolder = styled.div`
  ${commonSectionHolder}
  line-height: 46px;
`;

export const Selection = styled.span`
  ${commonSelection}
`;

export const SelectionInput = styled.input`
  ${commonSectionInput}
`;

export const SelectionCheckmark = styled.span`
  ${commonSectionCheckmark}
`;

export const Button = styled.button`
  ${commonButton}
  margin-right: 10px;

  &:last-of-type {
    margin-right: 0;

    ${Media.lg`
      margin: 5px;
    `}
  }

  ${Media.lg`
    margin: 5px;
  `}
`;
